export const START = "_START";
export const SUCCESS = "_SUCCESS";
export const ERROR = "_ERROR";

export const AUTH = "AUTH";
export const ORDER_STATUS = "ORDER_STATUS";
export const MENU = "MENU";
export const MENU_ITEM_PATCH = "MENU_ITEM_PATCH";
export const MENU_ITEM_REMOVE = "MENU_ITEM_REMOVE";

